module.exports = __webpack_public_path__ + "img/followDoc_e.05092f14.png";